import styles from "./Pests.module.css";
import { useThingSpeakFormattedData } from "../../../../respository/agristick";
import { useCropHealthData } from "../../../../respository/agristick/useCropHealthData";
import { useWeatherData } from "../../../../respository/agristick/useWeatherData";
import { useState } from "react";
import Modal from "../../../../components/Tools/Modal";

const Pests = () => {
  const [selectedSection, setSelectedSection] = useState<{
    type: "pest" | "disease";
    risk: "high" | "moderate" | "low";
  } | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [modalHtml, setModalHtml] = useState(
    "<p>This is <b>HTML content</b></p>",
  );
  const [modalTitle, setModalTitle] = useState("");
  const handleShowModal = (html: string, title: string) => {
    setModalHtml(html);
    setShowModal(true);
    setModalTitle(title);
  };
  const {
    data: sensorData,
    loading: sensorLoading,
    error: sensorError,
  } = useThingSpeakFormattedData({
    channelId: 1548738,
    field4: 1,
    field1: 2,
    results: 5,
  });

  const {
    data: cropHealthData,
    loading: cropLoading,
    error: cropError,
  } = useCropHealthData();

  const {
    data: weatherData,
    loading: weatherLoading,
    error: weatherError,
  } = useWeatherData(27.45945945945946, 80.93857600458162);

  const isLoading = sensorLoading || cropLoading || weatherLoading;
  const isError = sensorError || cropError || weatherError;

  if (isLoading) return <div>Loading all data sources...</div>;
  if (isError) return <div>Error fetching data from one or more sources.</div>;

  if (!sensorData || !cropHealthData || !weatherData) {
    return <div>Waiting for complete data...</div>;
  }

  const leafWetnessCount = sensorData.reduce((count, entry) => {
    if (entry?.leafWetnessValue && entry.leafWetnessValue > 10) {
      return count + 1;
    }
    return count;
  }, 0);

  const dataSetToCompare = {
    temp_min: weatherData.temperatureC,
    temp_max: weatherData.feelsLikeC,
    humidity: weatherData.humidity,
    rainfall: weatherData.rainfallMM,
    wind_speed: weatherData.windSpeedKph,
    soil_moisture: sensorData[sensorData.length - 1].soilMoistureValue,
    leaf_weatness: leafWetnessCount,
  };
  function countMatchingClimateConditions(
    favorable_climate: any,
    dataSetToCompare: any,
  ) {
    if (!favorable_climate || !dataSetToCompare) {
      return -1;
    }
    let matchCount = 0;

    for (const key in dataSetToCompare) {
      const value = dataSetToCompare[key];
      const climateRange = favorable_climate[key];

      if (
        climateRange &&
        typeof climateRange.min === "number" &&
        typeof climateRange.max === "number"
      ) {
        if (value >= climateRange.min && value <= climateRange.max) {
          matchCount++;
        }
      }
    }
    return matchCount;
  }
  function calculateRiskPercentage(matchCount: number, total: number) {
    if (total === 0) {
      return 0;
    }
    return Math.round((matchCount / total) * 100);
  }
  const diseaseMatches = cropHealthData.diseases.map((disease: any) => ({
    id: disease._id,
    name: disease.name_en,
    matchCount: countMatchingClimateConditions(
      disease.favorable_climate,
      dataSetToCompare,
    ),

    content_en: disease.content_en,
    content_hi: disease.content_hi,
  }));

  const pestMatches = cropHealthData.pests.map((pest: any) => ({
    id: pest._id,
    name: pest.name_en,
    matchCount: countMatchingClimateConditions(
      pest.favorable_climate,
      dataSetToCompare,
    ),
    content_en: pest.content_en,
    content_hi: pest.content_hi,
  }));

  console.log("Pest Matches:", pestMatches);
  console.log("Disease Matches:", diseaseMatches);

  //   here can be transformation

  const HighPest = pestMatches.filter((pest: any) => pest.matchCount > 4);
  const ModeratePest = pestMatches.filter(
    (pest: any) => pest.matchCount > 2 && pest.matchCount < 5,
  );
  const LowPest = pestMatches.filter(
    (pest: any) => pest.matchCount >= 0 && pest.matchCount < 3,
  );

  const HighDisease = diseaseMatches.filter(
    (disease: any) => disease.matchCount > 4,
  );
  const ModerateDisease = diseaseMatches.filter(
    (disease: any) => disease.matchCount > 2 && disease.matchCount < 5,
  );
  const LowDisease = diseaseMatches.filter(
    (disease: any) => disease.matchCount >= 0 && disease.matchCount < 3,
  );
  const getSelectedData = () => {
    if (!selectedSection) return [];

    const { type, risk } = selectedSection;

    const map: Record<string, any[]> = {
      pest_high: HighPest,
      pest_moderate: ModeratePest,
      pest_low: LowPest,
      disease_high: HighDisease,
      disease_moderate: ModerateDisease,
      disease_low: LowDisease,
    };

    return map[`${type}_${risk}`] || [];
  };

  const selectedData = getSelectedData();
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Pests and Diseases</h2>
      <div className={styles.mainContainer}>
        {/* Pest Column */}
        <div className={styles.col}>
          {selectedSection?.type === "pest" ? (
            <div className={styles.resultContainer}>
              <div className={styles.header}>
                <button onClick={() => setSelectedSection(null)}>← Back</button>
                <h3>{selectedSection.risk.toUpperCase()} Risk Pests</h3>
              </div>

              {selectedData.length > 0 ? (
                selectedData.map((item, index) => (
                  <div
                    onClick={() => handleShowModal(item.content_en, item.name)}
                    key={index}
                    className={`${styles.resultCard} ${
                      selectedSection.risk === "high"
                        ? styles.highCard
                        : selectedSection.risk === "moderate"
                          ? styles.midCard
                          : styles.lowCard
                    }`}
                  >
                    <h4>Name: {item.name}</h4>
                    <p>
                      Risk Percentage:{" "}
                      {calculateRiskPercentage(item.matchCount, 7)}%
                    </p>
                  </div>
                ))
              ) : (
                <p>No Pests found</p>
              )}
            </div>
          ) : (
            <>
              <div
                className={`${styles.card} ${styles.highCard}`}
                onClick={() =>
                  setSelectedSection({ type: "pest", risk: "high" })
                }
              >
                High Risk Pests
                {HighPest.length > 0 && (
                  <span className={styles.count}>{HighPest.length}</span>
                )}
              </div>
              <div
                className={`${styles.card} ${styles.midCard}`}
                onClick={() =>
                  setSelectedSection({ type: "pest", risk: "moderate" })
                }
              >
                Moderate Risk Pests
                {ModeratePest.length > 0 && (
                  <span className={styles.count}>{ModeratePest.length}</span>
                )}
              </div>
              <div
                className={`${styles.card} ${styles.lowCard}`}
                onClick={() =>
                  setSelectedSection({ type: "pest", risk: "low" })
                }
              >
                Low Risk Pests
                {LowPest.length > 0 && (
                  <span className={styles.count}>{LowPest.length}</span>
                )}
              </div>
            </>
          )}
        </div>

        {/* Disease Column */}
        <div className={styles.col}>
          {selectedSection?.type === "disease" ? (
            <div className={styles.resultContainer}>
              <div className={styles.header}>
                <button onClick={() => setSelectedSection(null)}>← Back</button>
                <h3>{selectedSection.risk.toUpperCase()} Risk Diseases</h3>
              </div>

              {selectedData.length > 0 ? (
                selectedData.map((item, index) => (
                  <div
                    onClick={() => handleShowModal(item.content_en, item.name)}
                    key={index}
                    className={`${styles.resultCard} ${
                      selectedSection.risk === "high"
                        ? styles.highCard
                        : selectedSection.risk === "moderate"
                          ? styles.midCard
                          : styles.lowCard
                    }`}
                  >
                    <h4>Name: {item.name}</h4>
                    <p>
                      Risk Percentage:{" "}
                      {calculateRiskPercentage(item.matchCount, 7)}%
                    </p>
                  </div>
                ))
              ) : (
                <p>No diseases found</p>
              )}
            </div>
          ) : (
            <>
              <div
                className={`${styles.card} ${styles.highCard}`}
                onClick={() =>
                  setSelectedSection({ type: "disease", risk: "high" })
                }
              >
                High Risk Diseases
                {HighDisease.length > 0 && (
                  <span className={styles.count}>{HighDisease.length}</span>
                )}
              </div>
              <div
                className={`${styles.card} ${styles.midCard}`}
                onClick={() =>
                  setSelectedSection({ type: "disease", risk: "moderate" })
                }
              >
                Moderate Risk Diseases
                {ModerateDisease.length > 0 && (
                  <span className={styles.count}>{ModerateDisease.length}</span>
                )}
              </div>
              <div
                className={`${styles.card} ${styles.lowCard}`}
                onClick={() =>
                  setSelectedSection({ type: "disease", risk: "low" })
                }
              >
                Low Risk Diseases
                {LowDisease.length > 0 && (
                  <span className={styles.count}>{LowDisease.length}</span>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      {showModal && (
        <Modal
          title={modalTitle}
          content={modalHtml}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default Pests;
